import { z } from 'zod'

export const createNumericField = (schema: z.ZodTypeAny) => {
  return z.preprocess((val) => {
    if (val === '' || val === null) return undefined
    if (typeof val === 'string' && val.trim() !== '') {
      const num = Number(val)
      return isNaN(num) ? val : num
    }
    return val
  }, schema)
}
